exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.lmg-list-panel {\n  height: 20vh;\n  overflow: scroll;\n  margin: 0;\n}\n.lmg-search > .v-input__control > .v-text-field__details {\n  display: none;\n}\n.lmg-search > .v-input__control > .v-input__slot {\n  margin: 0;\n}\n.lmg-search > .v-input__control > .v-input__slot > .v-text-field__slot > input {\n  margin: auto 0;\n}\n", ""]);

